module.exports = {
  SAVE_USER_DATA: 'SAVE_USER_DATA',
  SET_USER_AUTHENTICATION: 'SET_USER_AUTHENTICATION',
  SAVE_PERSONAL_ACCESS_RULES: 'SAVE_PERSONAL_ACCESS_RULES',
  LOGOUT: 'LOGOUT',
  SET_INSTITUTION_TYPE: 'SET_INSTITUTION_TYPE',
};
